import { MARKETING_TAGS } from '../../../../constants/marketingTags'
import ListingBadge, { BADGE_ORDER_PRIORITY } from './base'
import { hasMarketingTag, isForeclosure } from './utils'

export default class LikelyToGoToSaleBadge extends ListingBadge {
  static titleV2 = 'FCL Predict'
  static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.THIRD
  static shouldBeIncludedV2 = listing =>
    hasMarketingTag(listing, MARKETING_TAGS.GOTO) && isForeclosure(listing)
}
